import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductTypeAdditionalProductCost } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeAdditionalProductCostService extends TmsWebBaseEditCreateService<
  ProductTypeAdditionalProductCost,
  ProductTypeAdditionalProductCost
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductTypeAdditionalProductCost', $localize`Product Type Additional Product Cost`);
  }

  getForProductTypeSales(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductTypeAdditionalProductCost/${id}`);
  }

  getAdditionalProductCostsForProductType(productTypeId: string): Observable<ProductTypeAdditionalProductCost[]> {
    return this.httpService.get<ProductTypeAdditionalProductCost[]>(`${this.apiUrl}/ProductType/${productTypeId}`);
  }

  getAllAdditionalProductCostsForProductTypes(productTypeId: string): Observable<ProductTypeAdditionalProductCost[]> {
    return this.httpService.get<ProductTypeAdditionalProductCost[]>(
      `${this.apiUrl}/GetAllAdditionalProductCosts/${productTypeId}`,
    );
  }

  updateAdditionalProductCostsProductTypes(
    productTypeId: string,
    additionalProductCostIds: string[],
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateAdditionalProductCostsProductTypes`, {
      productTypeId,
      additionalProductCostIds,
    });
  }
}
